<template>
  <div
    ref="container"
    :id="id ? id : null"
    class="layer_section type-wide-a mpn-modal"
    :class="[addClass, classShowing]"
    :style="styles"
  >
    <div
      ref="refAnimateTarget"
      class="positioner"
      :style="styleContentVisible"
    >
      <slot v-if="showing" />
    </div>
  </div>
</template>

<script>
import { log } from '@/utils/common';

const modalState = {
  count: 0,
  stack: [],
};

export default {
  name: 'ModalLayout',
  props: {
    addClass: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isFirst: true,
      showing: false,
      visible: true,
      zIndex: 5000,
    };
  },
  computed: {
    classShowing() {
      return this.showing ? 'showing' : '';
    },
    styles() {
      return {
        zIndex: this.zIndex,
        backgroundColor: this.isFirst ? '' : 'transparent',
      };
    },
    styleContentVisible() {
      return this.visible ? '' : 'visibility: hidden';
    },
  },
  watch: {
  },
  created() {

  },
  methods: {
    open() {
      log('ModalLayout::open', `modal state count: ${modalState.count}`);
      modalState.count++;
      modalState.stack.push(this);
      this.zIndex += modalState.count;

      if (modalState.count > 1) {
        this.isFirst = false;
      }

      if (modalState.stack.length > 1) {
        const lastVm = modalState.stack[modalState.stack.length - 2];
        lastVm.hide(() => {
          console.log(this);
          this.showing = true;
        });
      } else {
        this.showing = true;
      }

      console.log(`modal state count: ${modalState.count}`);
    },
    hide(delayedShowing) {
      // function transitionHandler(cb) {
      //   console.log(this);
      //   cb();
      //   // this.$refs.refAnimateTarget.ontransitionend = null;
      //   // .removeEventListener('transitionend', transitionHandler);
      // }
      this.visible = false;
      // this.$refs.refAnimateTarget.ontransitionend = transitionHandler.bind(this, delayedShowing);
      // .addEventListener('transitionend', transitionHandler.bind(this, delayedShowing));
      setTimeout(() => {
        delayedShowing();
      }, 200);
    },
    show() {
      this.visible = true;
    },
    dispose() {
      modalState.count--;
      modalState.stack.pop();

      if (modalState.stack.length > 0) {
        modalState.stack[modalState.stack.length - 1].show();
      }

      this.showing = false;
      log('ModalLayout::dispose', `modal state count: ${modalState.count}`);
    },
  },
  destroyed() {
    this.dispose();
  }
};
</script>
<style scoped>
.mpn-modal {
  position: fixed;
}

.positioner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/global/ModalLayout.vue